import { createContext, useContext } from 'react';
import type { IUpdateImageEffectDraftOptions } from '@meitu/saas-editor-core/es/layers/image-layer';
import type { ILayerProps } from '@meitu/saas-editor-core/es/version-types';

export interface ActiveDataContextType {
    activeLayer: ILayerProps | null;
    setActiveData: (layer: ILayerProps | null, options?: IUpdateImageEffectDraftOptions) => void;
}

export const ActiveDataContext = createContext<ActiveDataContextType | null>(null);

export const useActiveData = () => {
    const context = useContext(ActiveDataContext);
    if (!context) {
        throw new Error('useActiveData must be used within an ActiveDataProvider');
    }
    return context;
};
